// These constants are used to determine the way elements are grouped. Whenever
// an element needs to be referenced, the app will loop over the items in this
// array
// To add a new group of elements to the UI, make sure to add it here

import InputBlocks from '../../editor/constants/blocks/inputs';
import InputGroupBlocks from '../../editor/constants/blocks/input-groups';
import ExtraBlocks from '../../editor/constants/blocks/extras';
import PaymentBlocks from '../../editor/constants/blocks/payments';


import InputElements from '../../editor/constants/elements/editor/inputs';
import InputGroupElements from '../../editor/constants/elements/editor/input-groups';
import ExtraElements from '../../editor/constants/elements/editor/extras';
import PaymentElements from '../../editor/constants/elements/editor/payment';

import PublicSiteInputElements from '../../shared/constants/elements/public-site/inputs';
import PublicSiteInputGroupElements from '../../shared/constants/elements/public-site/input-groups';
import PublicSiteExtraElements from '../../shared/constants/elements/public-site/extras';
import PublicSitePaymentElements from '../../shared/constants/elements/public-site/payments';


const ElementCategories = [
	{ // Inputs
		blockSpecification: InputBlocks,
		elementSpecification: InputElements,
		publicElementSpecification: PublicSiteInputElements,
		title: 'Form Fields',
		containsFormInputs: true
	},
	{ // Payment Elements
        blockSpecification: PaymentBlocks,
        elementSpecification: PaymentElements,
        publicElementSpecification: PublicSitePaymentElements,
        title: 'Payments',
        containsFormInputs: true
    },
	{ // Input Groups
		blockSpecification: InputGroupBlocks,
		elementSpecification: InputGroupElements,
		publicElementSpecification: PublicSiteInputGroupElements,
		title: 'Input Groups',
		containsFormInputs: true
	},
	{ // Extra Elements
		blockSpecification: ExtraBlocks,
		elementSpecification: ExtraElements,
		publicElementSpecification: PublicSiteExtraElements,
		title: 'Extras',
		containsFormInputs: false
	}
];

export default ElementCategories;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/constants/element-categories.js